import React from "react";
import "./BulkCreateSkeleton.scss";

const TILES = Array.from({ length: 8 });
const STEPS = [0, 1, 2, 3];

/** Page-shaped placeholder while the bulk-create chunk streams in. */
const BulkCreateSkeleton = () => (
  <div
    className="page-content bcp-page-skel"
    aria-busy="true"
    aria-label="Loading bulk create"
  >
    <div className="bcp-page-skel__inner">
      <div className="bcp-page-skel__crumb">
        <span className="bcp-skel" style={{ width: 72 }} />
        <span className="bcp-skel" style={{ width: 110 }} />
      </div>
      <div className="bcp-page-skel__steps">
        {STEPS.map((i) => (
          <span
            key={i}
            className={`bcp-skel bcp-page-skel__step${i === 1 ? " is-on" : ""}`}
          />
        ))}
      </div>
      <span className="bcp-skel bcp-page-skel__h" />
      <span className="bcp-skel bcp-page-skel__sub" />
      <div className="bcp-page-skel__card">
        <span className="bcp-skel bcp-page-skel__prompt" />
        <div className="bcp-page-skel__tiles">
          {TILES.map((_, i) => (
            <span key={i} className="bcp-skel bcp-page-skel__tile" />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default BulkCreateSkeleton;
